import React from 'react';
import { Channel } from 'stream-chat';
import { TabNavigationShortcutsValues } from 'src/components/ShortcutsDrawer/shortcutsSidebarConsts';
import { ChannelOptionData } from 'src/components/Channels/ChannelSidebarItem';

/**
 * This hook handles the channel navigation shortcut.
 * @param channels: channels array
 * @param currentChannelIndex: current active channel index
 * @param selectChannelHandler: function to select channel
 */

export const useChannelNavigationShortcut = (
  channels: Array<ChannelOptionData | Channel>,
  currentChannelIndex: number,
  selectChannelHandler: (channel: ChannelOptionData | Channel) => void,
) => {
  const handleKeyDown = React.useCallback(
    (event: KeyboardEvent) => {
      let destinationChannel;
      let tabNavTrigger = false;
      if (currentChannelIndex === -1) return;
      if (event.getModifierState('Control') || event.getModifierState('Meta')) {
        if (event.key === TabNavigationShortcutsValues.SELECT_NEXT_KEY) {
          tabNavTrigger = true;
          const nextChannel = channels[currentChannelIndex + 1];
          // go to next channel
          if (nextChannel) {
            destinationChannel = nextChannel;
          }
        }

        if (event.key === TabNavigationShortcutsValues.SELECT_PREVIOUS_KEY) {
          tabNavTrigger = true;
          // go to previous channel
          const previousChannel = channels[currentChannelIndex - 1];
          if (previousChannel) {
            destinationChannel = previousChannel;
          }
        }
      }

      // if tab nav trigger is true, prevent default behavior of browser back/next navigation
      if (tabNavTrigger) {
        event.preventDefault();
      }

      if (destinationChannel) {
        selectChannelHandler(destinationChannel);
      }
    },
    [currentChannelIndex, channels],
  );

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown, false);
    return () => {
      window.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [handleKeyDown]);
};
